const COLOR = { info: "text-slate-400", warn: "text-[#F59E0B]", error: "text-[#EF4444]", trade: "text-[#14F195]" };

export const ActivityLog = ({ logs }) => (
  <div className="panel rise flex flex-col" style={{ animationDelay: "200ms" }} data-testid="activity-log">
    <div className="px-5 py-4 border-b border-[#1E293B] flex items-center gap-2">
      <span className="w-1.5 h-1.5 rounded-full bg-[#14F195] pulse-dot" />
      <div className="panel-title">Engine telemetry</div>
    </div>
    <div className="p-4 overflow-auto scroll-thin max-h-[420px] font-mono text-[11px] leading-relaxed space-y-1 bg-[#07090D]">
      {logs.length === 0 && <div className="text-slate-500">booting…</div>}
      {logs.map((l) => (
        <div key={l.id} className="flex gap-3" data-testid="log-line">
          <span className="text-slate-500 shrink-0">{new Date(l.ts).toLocaleTimeString([], { hour12: false })}</span>
          <span className={`${COLOR[l.level] || COLOR.info} break-words`}>{l.msg}</span>
        </div>
      ))}
    </div>
  </div>
);
